import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Divider, Paper } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Delete from "@material-ui/icons/Delete";
import calculateValueCheque from "../../../utility/CalculateValueCheque/calculateValueCheque";
import NumberFormat from "react-number-format";
import moment from "moment";
import { Link } from "react-router-dom";

const ChequeContractStepSide = (props) => {
  const { firstCheque, setFirstCheque } = props;

  const handleRemove = (cheque) => {
    let newFirstCheque = firstCheque.filter((c) => c.id != cheque.id);

    setFirstCheque(newFirstCheque);
  };

  return (
    <Wrapper>
      <Box ml={1}>
        <Box mb={2}>
          <Paper>
            <Box p={2}>
              <Box display={"flex"}>
                <Box flexGrow={1} textAlign={"left"}>
                  ارزش کل
                </Box>
                <Box>
                  <NumberFormat
                    value={firstCheque.reduce(
                      (prevValue, currentValue) =>
                        prevValue +
                        calculateValueCheque(
                          props.percent,
                          currentValue.amount,
                          parseInt(
                            moment(currentValue.due_date).diff(
                              moment(props.originDate),
                              "days",
                            ),
                          ),
                        ),
                      0,
                    )}
                    thousandSeparator={true}
                    displayType={"text"}
                  />
                </Box>
              </Box>
              <Box display={"flex"} mt={1}>
                <Box flexGrow={1} textAlign={"left"}>
                  مبلغ کل
                </Box>
                <Box>
                  {
                    <NumberFormat
                      value={firstCheque.reduce(
                        (prevValue, currentValue) =>
                          prevValue + currentValue.amount,
                        0,
                      )}
                      thousandSeparator={true}
                      displayType={"text"}
                    />
                  }
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box>
        <Box mb={2}>
          <Paper>
            <Box p={2}>چک های انتخاب شده</Box>
            <Box p={2}>
              {firstCheque.map((cheque) => {
                let day_left = parseInt(
                  moment(cheque.due_date).diff(
                    moment(props.originDate),
                    "days",
                  ),
                );
                return (
                  <Wrapper>
                    <Box fullWidth>
                      <Link to={`/cheque/edit/${cheque.id}`} target={"_blank"}>
                        <Box display={"flex"} pb={1} pt={1}>
                          <Box>{cheque.id}-</Box>
                          <Box flexGrow={1} style={{ textAlign: "right" }}>
                            {cheque.giver_user_fullname}
                          </Box>
                          <Box>{cheque.reciver_user_fullname}</Box>
                        </Box>
                      </Link>

                      <Box display={"flex"} pb={1} pt={1}>
                        <Box flexGrow={1} style={{ textAlign: "right" }}>
                          <NumberFormat
                            value={cheque.amount}
                            thousandSeparator={true}
                            displayType={"text"}
                          />
                        </Box>
                        <Box>
                          {
                            <NumberFormat
                              value={calculateValueCheque(
                                props.percent,
                                cheque.amount,
                                day_left,
                              )}
                              thousandSeparator={true}
                              displayType={"text"}
                            />
                          }
                        </Box>
                      </Box>

                      <Box display={"flex"} alignItems="center">
                        <Box flexGrow={1} style={{ textAlign: "right" }}>
                          {cheque.due_date_fa}
                        </Box>
                        <Box>
                          {day_left > 0 ? (
                            <Box display={"flex"}>
                              <Box>{day_left}</Box>
                              <Box>روز مانده</Box>
                            </Box>
                          ) : (
                            <Box>سر رسید</Box>
                          )}
                        </Box>
                        <Box>
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="span"
                            onClick={(e) => {
                              handleRemove(cheque);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                    <Divider />
                  </Wrapper>
                );
              })}
            </Box>
          </Paper>
        </Box>
        {/*<Box>*/}
        {/*    {props.step == 1? <Button variant={"contained"} color={"primary"} fullWidth={true}*/}
        {/*                              onClick={e => {props.setStep(2)}}>*/}
        {/*        مرحله دوم معامله*/}
        {/*    </Button>:<Grid container={true}>*/}
        {/*        <Grid item xs={6}>*/}
        {/*           <Box p={0.2}>*/}
        {/*               <Button variant={"contained"} color={"primary"} fullWidth={true}*/}
        {/*                       onClick={e => {props.setStep(1)}}>*/}
        {/*                   برگشت اول معامله*/}
        {/*               </Button>*/}
        {/*           </Box>*/}
        {/*        </Grid>*/}
        {/*        <Grid item xs={6}>*/}
        {/*           <Box p={0.2}>*/}
        {/*               <Button variant={"contained"} color={"primary"} fullWidth={true}*/}
        {/*                       onClick={e => {props.setStep(3)}}>*/}
        {/*                   مرحله سوم معامله*/}
        {/*               </Button>*/}
        {/*           </Box>*/}
        {/*        </Grid>*/}
        {/*    </Grid>}*/}

        {/*</Box>*/}
      </Box>
    </Wrapper>
  );
};

export default ChequeContractStepSide;
